import {SimplePage} from "../../elements/Pages";
import React, {useEffect, useState} from "react";

import {useQuery} from "@tanstack/react-query";
import ListViewTable, {TableLink} from "../../elements/tables/ListViewTable";
import SchoolYearFilter from "../../elements/SchoolYearFilter";
import {useSchoolYears} from "../../../contexts/SchoolYearContext";
import {getCourseListExcel, getCourses} from "../../../api/courses";
import {DownloadButton} from "../../elements/Buttons";

const columns = [
    {
        accessorKey: "course_number",
        id: "course_number",
        header: "Nr.",
        enableColumnFilter: false,
        classNames: "text-imsblue-600",
    },
    {
        accessorKey: "school_subject.name",
        id: "school_subject",
        header: "Fach",
        enableColumnFilter: true,
        // filterFn: "containsString",
    },
    {
        accessorKey: "taught_in",
        id: "taught_in",
        header: "Unterricht in",
        enableColumnFilter: false,
    },
    {
        accessorKey: "lessons_per_week",
        id: "lessons_per_week",
        header: "Wochenstd.",
        enableColumnFilter: false,
    },
    // {
    //     accessorKey: "major",
    //     id: "major",
    //     header: "Kernfach",
    //     columnType: "yesno",
    //     enableColumnFilter: true
    // },
    {
        accessorKey: "number_of_students",
        id: "number_of_students",
        header: "Schüler",
        enableColumnFilter: false,
    },
    {
        accessorKey: "teacher.full_name",
        id: "teacher",
        header: "LehrerIn",
        enableColumnFilter: true,
        filterFn: "containsString",
        labelAttr: "full_name",
    },
    {
        accessorKey: "id",
        id: "link",
        cell: (info) => (
            <TableLink
                label="Kursbuch"
                to={`/class-register/courses/${info.getValue()}`}
            />
        ),
        disableRowLink: true,
        header: "Kursbuch",
        enableColumnFilter: false,
    },
    {
        accessorKey: "id",
        id: "nb",
        cell: (info) => (
            <TableLink
                label="Notenblatt"
                to={`/grades/courses/${info.getValue()}/notenblatt`}
            />
        ),
        disableRowLink: true,
        header: "Notenblatt",
        enableColumnFilter: false,
    },
    {
        accessorKey: "id",
        id: "hw",
        cell: (info) => (
            <TableLink
                label="HA & Klausuren"
                to={`/class-register/courses/${info.getValue()}/homework`}
            />
        ),
        disableRowLink: true,
        header: "Hausaufgaben",
        enableColumnFilter: false,
    },
];

export default function CourseList() {

    const {schoolYears, currentSchoolYear} = useSchoolYears();
    const [ rowSelection, setRowSelection] = useState([]);
    const [schoolYearId, setSchoolYearId] = useState();

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["courses", schoolYearId],
        () => getCourses(schoolYearId),
        {
            enabled: !!schoolYearId, refetchInterval: 1000 * 60 * 60 * 24
        }
    );

    useEffect(() => {
        if (currentSchoolYear) setSchoolYearId(currentSchoolYear["id"]);
    }, [currentSchoolYear]);

    function getRowLink(row) {
        return `/courses/${row.original.id}/`;
    }

    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">
                            Kurse
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <DownloadButton
                            apiFunction={() => getCourseListExcel(schoolYearId)}
                            fileName="Kursliste.xls"
                            label="Kursliste herunterladen"/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <SchoolYearFilter
                                schoolYears={schoolYears}
                                schoolYearId={schoolYearId}
                                setSchoolYearId={setSchoolYearId}
                            />
                        </div>

                        <div className="scrollbarHeightListViewTable inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    rowSelection={rowSelection}
                                    setRowSelection={setRowSelection}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
